export default "__VITE_ASSET__CGdb2fQ2__"